var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:_vm.btn_type,attrs:{"type":"button","value":_vm.value},on:{"click":function($event){return _vm.input(_vm.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }